import { escapeHtml } from "./escapeHtml.js";

export type BrandIconSize = "small" | "medium" | "large";

export interface BrandIconOptions {
  size?: BrandIconSize;
  className?: string;
  alt?: string;
}

export function renderBrandIcon({
  size = "medium",
  className = "",
  alt = "",
}: BrandIconOptions = {}): string {
  const classes = ["brand-icon", `brand-icon--${size}`, className]
    .filter(Boolean)
    .map(escapeHtml)
    .join(" ");

  return `<img class="${classes}" src="/favicon-ui.png" width="32" height="32" alt="${escapeHtml(alt)}" ${alt ? "" : 'aria-hidden="true"'} draggable="false" />`;
}
